import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { searchList, listUser, logoutAdmin } from '../_actions/user_action';
import '../css_admin/Header.css';
import '../css_admin/Body.css';

/* 폰트어썸 import */
// import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Map
import MapContainer from './MapContainer';

// Detail
import Detail from './Detail';
import { getAdminAccount, clearSession } from '../utils/session';

function Management() {
    const dispatch = useDispatch();

    const adminAccount = getAdminAccount() || {};

    const onLogoutHandler = async (event) => {
        event.preventDefault();
        await dispatch(logoutAdmin({ email: adminAccount.email }));
        clearSession();
        window.location.replace('/');
    };

    // <!--
    // Start - 장비 설정 관리  Manage equipment and user settings
    const [userListInfo, setUserListInfo] = useState([]);

    useEffect(() => {
        console.log('listUser', search);

        setSearch({search: ""});
        setSearched(false);

        dispatch(listUser()).then(response => {
            if (response.payload.listSuccess) {
                let userList = response.payload.userList;
                setUserListInfo(userList);
            }
        })
        .catch((err) => console.log(err));
    }, []);

    // Search
    const [search, setSearch] = useState({search: ""});
    const [searched, setSearched] = useState(false);

    const onChangeListSearch = (e) => {
        console.log(e.target.name, e.target.value);

        const { value, name } = e.target;
        setSearch({
            ...search,
            [name]: value
        });
    };

    const [searchListInfo, setSearchListInfo] = useState([]);

    const handleListSearch = (e) => {
        e.preventDefault();

        setUserListInfo([]);
        setIsDetail(false);
        setUserId("");

        let body = {
            search: search.search
        };

        console.log('searchList', body);
        dispatch(searchList(body)).then(response => {
            if (response.payload.listSuccess) {
                let userList = response.payload.userList;
                setSearchListInfo(userList);
                setSearched(true);
                console.log(userListInfo.length);
                console.log(searched);
            } else {
                alert(response.payload.message);
            }
        });
    };

    const [isDetail, setIsDetail] = useState(false);
    const [userId, setUserId] = useState("");

    return (
        <div className="container">
            <div className="header-wrap">
                <div className="headerBtn">
                    <h1>장비 관리</h1>
                </div>
                <div className="info-wrap">
                    <div className="info-id">
                        <span>{adminAccount.name}</span>
                        <button className="logout-btn" onClick={onLogoutHandler}>로그아웃</button>
                    </div>
                    <div className="info-email">
                        {adminAccount.email}
                    </div>
                </div>
            </div>

            <div className="bodyManagement">
                <div className="ManagementGrop1">
                    <div className="ManagementLayout">

                        <div className="setting-layout-header">
                            <h3>장비 설정 관리</h3> <span>Manage equipment settings</span>
                        </div>
                        <div className="ManagementBody">
                            <div className="ManagementGuide">
                                <div className="ManagementGuideIcon">
                                    <FontAwesomeIcon icon={faLocationDot} style={{ color: '#75C03A', fontSize: '26px' }} /> <span>온라인-정상동작</span>
                                    <FontAwesomeIcon icon={faLocationDot} style={{ color: '#DB2F18', fontSize: '26px' }} /> <span>오프라인-점검필요</span>
                                    <FontAwesomeIcon icon={faLocationDot} style={{ color: '#F29729', fontSize: '26px' }} /> <span>데이터 에러-통신오류</span>
                                    {/* <FontAwesomeIcon icon={faLocationDot} style={{ color: '#BABABA', fontSize: '26px' }} /> <span>대기상태</span> */}
                                </div>
                                {/* <div>
                                    <input
                                        id="search"
                                        name="search"
                                        onChange={onChangeListSearch}
                                        className="textInput8"
                                        value={search.search}
                                        type="text"
                                        placeholder="상호 / 장비번호 / 아이디로 검색" />
                                    <FontAwesomeIcon
                                        onClick={handleListSearch}
                                        icon={faMagnifyingGlass}
                                        style={{ color: '#130C0E', fontSize: '26px', cursor: 'pointer' }} />
                                </div> */}
                            </div>
                            <div className="ManagementMap">
                            {
                                searched === false && userListInfo.length >= 0 &&
                                <MapContainer userInfos={userListInfo} setisdetail={setIsDetail} setuserid={setUserId} />
                            }
                            {
                                searched === true && searchListInfo.length >= 0 &&
                                <MapContainer userInfos={searchListInfo} setisdetail={setIsDetail} setuserid={setUserId} />
                            }
                            </div>
                            <div className="ManagementUserBody">
                            {
                                isDetail === true && userId !== "" &&
                                searched === false && userListInfo.length >= 0 &&
                                <Detail userId={userId} userInfos={userListInfo} />
                            }
                            {
                                isDetail === true && userId !== "" &&
                                searched === true && searchListInfo.length >= 0 &&
                                <Detail userId={userId} userInfos={searchListInfo} />
                            }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Management;
